import { clamp } from "lodash-es";
import { getGoalPortfolioSubtitle } from "web_myplann/Goals/Helpers/getGoalPortfolioSubtitle";
import { getPortfolioDomainItemLabel } from "web_myplann/Goals/Helpers/getPortfolioDomainItemLabel";
import {
	type GoalPortfolioResponseDTO,
	GoalPortfolioTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";

export const useGoalDetailSolutionItem = (
	portfolio: GoalPortfolioResponseDTO,
	dueYear?: number,
) => {
	const { t } = useResource();

	const isSetAside = portfolio.type === GoalPortfolioTypeEnum.SetAside;

	const domainLabel = portfolio.domain
		? t(getPortfolioDomainItemLabel(portfolio.domain))
		: "";
	const title = portfolio.name || portfolio.product || domainLabel;
	const subtitle = getGoalPortfolioSubtitle(portfolio, title, domainLabel);

	const allocationPercent = clamp(portfolio.usagePercent ?? 0, 0, 100);
	const showAllocation = !isSetAside && allocationPercent < 100;

	const displayValue = isSetAside
		? (portfolio.portfolioValue ?? 0)
		: (portfolio.usageValue ?? 0);

	const expectedCoverage = portfolio.expectedCoverage ?? 0;
	const showProjection =
		!isSetAside && expectedCoverage > 0 && dueYear !== undefined;

	return {
		title,
		subtitle,
		allocationPercent,
		showAllocation,
		displayValue,
		expectedCoverage,
		showProjection,
	};
};
